<template>
  <div :class="$style.box">
    <!-- 礼包中心弹窗 -->
    <GiftDialog ref="dialog" @refreshAllGift="refreshAllGift"></GiftDialog>
    <TopHeader headerTitle="全部礼包" :isShowMenuIcon="false" />
    <CircleBaseBox :class="$style.list">
      <div
        v-for="item of allGiftList"
        :key="item.id"
        :class="$style.item"
        @click="handleLinkTo('giftCenter.details', { giftId: item.id })"
      >
        <img :src="item.icon" />
        <div>
          <p>{{ item.title }}</p>
          <p>{{ item.description }}</p>
        </div>
        <button v-if="item.can_get == 1" @click.stop="handleReceiveGift(item)">领取</button>
        <button style="background-color: #9d9d9d" v-else @click.stop="alreadyReceivedGift">
          已领取
        </button>
      </div>
    </CircleBaseBox>
  </div>
</template>

<script>
import TopHeader from '_c/TopHeader';
import GiftDialog from './components/GiftDialog';
import CircleBaseBox from '_c/CircleBaseBox';
import VerLayout from './components/VerLayout';
import { mapState, mapMutations, mapActions } from 'vuex';
import { getAllGift, getNewGift } from '@/api/giftCenter';

export default {
  data() {
    return {
      allGiftList: []
    }
  },
  components: {
    GiftDialog,
    CircleBaseBox,
    TopHeader,
    VerLayout,
  },
  created() {
    this.getAllGift()
  },
  methods: {
    ...mapMutations('giftCenter', {
      SHOW_GIFT_DIALOG: 'SHOW_GIFT_DIALOG',
      SET_GIFT_ITEM: 'SET_GIFT_ITEM'
    }),
    async getAllGift() {
      if (!this.$route.query.plateId) {
        // 礼包上新
        const r = await getNewGift()
        this.allGiftList = [...r.data]
        return
      }
      const r = await getAllGift({ plate_id: this.$route.query.plateId })
      this.allGiftList = [...r.data]
    },
    refreshAllGift() {
      this.getAllGift()
    },
    // 路由跳转
    handleLinkTo(name, query) {
      this.$router.push({ name, query })
    },
    // 打开领取礼包弹窗
    handleReceiveGift(item) {
      this.SHOW_GIFT_DIALOG(true)
      this.SET_GIFT_ITEM(item)
    },
    // 点击已领取按钮
    alreadyReceivedGift() {
      this.$refs.dialog.showNormalDialog('receivedGift')
    },
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
@import '~@/styles/_variable.scss';
.box {
  width: 100vw;
  height: 100vh;
  background-color: #efefef;
  .list {
    margin-top: 8px;
    height: calc(100vh - 65px);
    overflow-y: auto;
    .item {
      margin: 12px 0px 8px 8px;
      display: flex;
      align-items: center;
      height: 45px !important;
      img {
        width: 45px;
      }
      div {
        margin: 0px 8px;
        width: 218px;
        p:first-child {
          margin-bottom: 8px;
          font-size: 11px;
        }
        p:last-child {
          @include ellipsis(1);
          font-size: 10px;
          color: #9f9f9f;
        }
      }
      button {
        @include clearBtnDefaultStyle;
        padding: 0;
        width: $buttonWidth;
        height: $buttonHeight;
        color: #fff;
        font-size: 10px;
        background-color: $buttonColor;
        border-radius: 15px;
      }
    }
  }
  .list::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
  }
}
</style>
